import { Icon } from "@/components/ui/icon";
import * as Dialog from "@radix-ui/react-dialog";
import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Footer } from "./footer";
import { Header } from "./header";
import { Sidebar } from "./sidebar";

export function AppShell() {
  const [opened, setOpened] = useState(false);
  const [desktop, setDesktop] = useState(
    () => window.matchMedia("(min-width: 1200px)").matches,
  );
  const menuButton = useRef<HTMLButtonElement>(null);
  const main = useRef<HTMLElement>(null);
  const { key } = useLocation();

  useEffect(() => setOpened(false), [key]);
  useEffect(() => {
    const media = window.matchMedia("(min-width: 1200px)");
    const update = () => {
      setDesktop(media.matches);
      setOpened(false);
    };
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  return (
    <div className="scp-shell">
      <a href="#main-content" className="scp-skip-link">
        Saltar al contenido
      </a>
      {desktop && (
        <aside className="scp-sidebar-desktop">
          <Sidebar />
        </aside>
      )}
      <div className="scp-workspace">
        <header className="scp-header">
          <Header
            onToggleDrawer={() => setOpened(true)}
            drawerOpen={opened}
            menuButtonRef={menuButton}
          />
        </header>
        <main
          id="main-content"
          ref={main}
          tabIndex={-1}
          className="page-content scp-main"
        >
          <Outlet />
        </main>
        <Footer />
      </div>
      <Dialog.Root open={!desktop && opened} onOpenChange={setOpened}>
        <Dialog.Portal>
          <Dialog.Overlay className="scp-drawer-overlay" />
          <Dialog.Content
            id="navigation-drawer"
            className="scp-drawer"
            aria-describedby={undefined}
            onCloseAutoFocus={(event) => {
              event.preventDefault();
              (window.matchMedia("(min-width: 1200px)").matches
                ? main.current
                : menuButton.current
              )?.focus();
            }}
          >
            <Dialog.Title className="sr-only">
              Navegación principal
            </Dialog.Title>
            <Dialog.Close className="scp-drawer-close" aria-label="Cerrar menú">
              <Icon name="close" className="" aria-hidden="true" />
            </Dialog.Close>
            <Sidebar />
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </div>
  );
}
